<div class="row ml-1 mt-2">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET' && isAdmin">
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console</a>
    </small>
    <small *ngIf="accountCategory== 'RENTAL_FLEET' && isDeveloper">
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Developer Portal</a>
    </small>
    <small *ngIf="(accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY') && isAdmin">
      <a [routerLink]="['/commercial-fleet']" class="text-secondary">Admin Console</a>
    </small>
    <small *ngIf="(accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY') && isDeveloper">
      <a [routerLink]="['/commercial-fleet']" class="text-secondary">Developer Portal</a>
    </small>
    <small *ngIf="accountCategory== 'DEALER' && isAdmin">
      <a [routerLink]="['/dealer']" class="text-secondary">Admin Console</a>
    </small>
    <!-- <small *ngIf="accountCategory== 'DEALER' && isDeveloper">
      <a [routerLink]="['/dealer']" class="text-secondary">Developer Portal</a>
    </small> -->
  </div>
</div>

<div *ngIf="showSearchResult" class="row align-items-center justify-content-center no-gutters">
  <div class="col-12">
    <app-search-results [locationList]="searchedLocationList" [servicePackageList]="searchedServicePackageList"
      [vehicleList]="searchedVehicleList" (selectedItemEmitter)="onSearchItemDetail($event);"
      (selectedItemCloseEmitter)="selectedSearchItemForView=null;" #searchResult></app-search-results>
  </div>
</div>


<div *ngIf="!showSearchResult" class="row align-items-center justify-content-center home-container">
  <div class="col pl-0 pr-0">
    <div *ngIf="isAdmin" class="row text-center ml-1 mr-1 mt-4">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/b2b.png" alt="Account Management" routerLink="/account-management" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Account Management</span><br>
        <span class="font-nissan-brand-w01-light font-12">Manage vehicles and packages</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/b2b.png" alt="Business Entity" routerLink="/business-entity" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Business Entity</span><br>
        <span class="font-nissan-brand-w01-light font-12">view Business Entities</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/usage.png" alt="invoices" routerLink="/invoices" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Invoices</span><br>
        <span class="font-nissan-brand-w01-light font-12">View invoices</span>
      </div>
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/user.png" alt="accounts" routerLink="/customers" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Customers</span><br>
        <span class="font-nissan-brand-w01-light font-12">Manage Customers</span>
      </div> -->
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/users.png" alt="consent management"
          routerLink="/admin-roles" /><br>
        <span class="font-nissan-brand-w01-bold font-14">User Roles</span><br>
        <span class="font-nissan-brand-w01-light font-12">Add or manage users</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/question.png" alt="admin roles" routerLink="/support" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Support</span><br>
        <span class="font-nissan-brand-w01-light font-12">Access support services</span>
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/gear.png" alt="service Packaging" routerLink="/settings" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Settings</span><br>
        <span class="font-nissan-brand-w01-light font-12">Manage account & brand settings</span>
      </div>
      <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid icon" src="assets/images/journey/vehicle-journey.png" alt="Streaming" routerLink="/vehicle-journey" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Vehicle Journey</span><br>
        <span class="font-nissan-brand-w01-light font-12">Vehicle Journey Data</span>
      </div> -->
    </div>
    <div *ngIf="isDeveloper" class="row text-center ml-1 mr-1 mt-4">
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
        <img class="img-fluid  icon" src="assets/images/developer-access.png" alt="developer access"
          (click)="apiAccess.openDeveloperAccess()" /><br>
        <span class="font-nissan-brand-w01-bold font-14">Developer Access</span><br>
        <span class="font-nissan-brand-w01-light font-12">View and manage API access</span>
      </div>
    </div>
    <div *ngIf="!isAdmin && !isDeveloper" class="row text-center ml-5 mr-5 pt-4">
      <h4 class="text-muted">Access Denied! You don't have the permission to access this portal.</h4>
    </div>
  </div>
</div>





<!-- Modal API Access -->
<developer-access #apiAccess></developer-access>

<!-- TnC Model -->
<button type="button" class="btn btn-primary" id="openTnc" [hidden]="true" data-toggle="modal" data-target="#tncModel"
  data-backdrop="static" data-keyboard="false">Hidden Btn</button>

<div class="modal fade" id="tncModel" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="apiAccessTitle">Terms and Conditions Acceptence</h5>
        <!-- <h5 class="modal-title" id="apiAccessTitle">{{tnc.name}}</h5> -->
        <button id="closeTnc" type="button" class="close" [hidden]="true" data-dismiss="modal">CANCEL</button>
      </div>
      <div class="modal-body">
        <div class="row p-3">
          <div class="col-12 mt-4">
            <div class="custom-control custom-checkbox float-left">
              <input type="checkbox" class="custom-control-input font13-400" id="cbAcceptTnC"
                [(ngModel)]="isTnCAccepted">
              <label class="custom-control-label lh-23" for="cbAcceptTnC">Check here to indicate that you have read and
                agree to the&nbsp;
                <a class="font14-600-link" href="{{tnc.url}}" target="_blank">NCC Terms and Conditions.</a>
              </label>
            </div>
          </div>
          <div class="col-12 mt-3 font14-400"><span class="text-muted">Effective
              From:&nbsp;</span><span>{{tnc.effectiveDate | date:'MMM d, y'}}</span></div>

          <div class="col-12 mt-5 text-center">
            <button type="button" [disabled]="!isTnCAccepted" class="btn btn-primary btn-block"
              (click)="acceptTnc()">Accept and Continue</button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row width-100">
          <div class="col-12">
            <button type="button" [hidden]="true" [disabled]="!isTnCAccepted" class="btn btn-primary float-right"
              (click)="acceptTnc()">Accept</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>